window.LazyLoad = require('vanilla-lazyload');

window.onload = function () {
  //lazy loading for images
  window.LazyLoad = new LazyLoad({
    elements_selector: "img.lazy",
    // When the .lazy div enters the viewport...
    callback_enter: function(el) {}
  });
};
